var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCreateExportConfiguration } from '@data/exportConfiguration/exportConfigurationActions';
import FormInput from '@shared/forms/FormInput';
import FSButton from '@components/FSButton';
import React, { useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import toast from 'react-hot-toast';
import { RiFile2Fill, RiUploadCloud2Line } from 'react-icons/ri';
export function ExportConfiguration() {
    var _a = __read(useState(8), 2), flag = _a[0], setFlag = _a[1];
    var _b = __read(useState(), 2), template = _b[0], setTemplate = _b[1];
    var _c = __read(useState(), 2), templateName = _c[0], setTemplateName = _c[1];
    var _d = __read(useState(), 2), json = _d[0], setJson = _d[1];
    var _e = __read(useState(), 2), jsonName = _e[0], setJsonName = _e[1];
    var createExportMutation = useCreateExportConfiguration();
    var templateDropzone = useDropzone({
        onDrop: onTemplateDrop,
        noClick: true,
    });
    var jsonDropzone = useDropzone({
        onDrop: onJsonConfigDrop,
        noClick: true,
    });
    function handleTemplateBrowseClick() {
        var _a;
        (_a = templateDropzone.inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }
    function handleJsonBrowseClick() {
        var _a;
        (_a = jsonDropzone.inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }
    function onTemplateDrop(acceptedFiles) {
        var f = acceptedFiles[0];
        if (f.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            toast.error('.xlsx file only');
        }
        setTemplate(f);
        setTemplateName(f.name);
    }
    function onJsonConfigDrop(acceptedFiles) {
        return __awaiter(this, void 0, void 0, function () {
            var f, json, dataMapping;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        f = acceptedFiles[0];
                        if (f.type !== 'application/json') {
                            toast.error('.json file only');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, f.text()];
                    case 1:
                        json = _a.sent();
                        dataMapping = JSON.parse(json);
                        setJson(dataMapping);
                        setJsonName(f.name);
                        return [2 /*return*/];
                }
            });
        });
    }
    var templateStyle = useMemo(function () { return (__assign({}, (templateDropzone.isDragAccept
        ? {
            backgroundColor: '#f6f6f6',
        }
        : {}))); }, [templateDropzone.isDragAccept]);
    var jsonStyle = useMemo(function () { return (__assign({}, (jsonDropzone.isDragAccept
        ? {
            backgroundColor: '#f6f6f6',
        }
        : {}))); }, [jsonDropzone.isDragAccept]);
    return (React.createElement("div", { className: "fs-import-container" },
        React.createElement("div", { className: "import-new" },
            React.createElement(FormInput, { label: "Flag", name: "flag", value: flag, type: "text", onChange: function (e) { return setFlag(+e.target.value); } }),
            React.createElement("div", __assign({ className: "import-new-dropfield" }, templateDropzone.getRootProps({ templateStyle: templateStyle })),
                React.createElement("input", __assign({ type: "file", ref: templateDropzone.inputRef, style: { display: 'none' } }, templateDropzone.getInputProps())),
                template ? React.createElement(RiFile2Fill, null) : React.createElement(RiUploadCloud2Line, null),
                templateName ? React.createElement("p", null, templateName) : React.createElement("p", null, "Drag your template .xlsx file here")),
            React.createElement("div", { className: "import-new-browse" },
                React.createElement("span", { className: "import-new-or" },
                    React.createElement("span", { className: "line" }),
                    "OR",
                    React.createElement("span", { className: "line" })),
                React.createElement(FSButton, { title: "Browse", onClick: handleTemplateBrowseClick }))),
        React.createElement("div", { className: "import-new" },
            React.createElement("div", __assign({ className: "import-new-dropfield" }, jsonDropzone.getRootProps({ jsonStyle: jsonStyle })),
                React.createElement("input", __assign({ type: "file", ref: jsonDropzone.inputRef, style: { display: 'none' } }, jsonDropzone.getInputProps())),
                json ? React.createElement(RiFile2Fill, null) : React.createElement(RiUploadCloud2Line, null),
                jsonName ? React.createElement("p", null, jsonName) : React.createElement("p", null, "Drag your data mapping .json config file here")),
            React.createElement("div", { className: "import-new-browse" },
                React.createElement("span", { className: "import-new-or" },
                    React.createElement("span", { className: "line" }),
                    "OR",
                    React.createElement("span", { className: "line" })),
                React.createElement(FSButton, { title: "Browse", onClick: handleJsonBrowseClick }))),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement(FSButton, { title: "Save", disabled: !json || !template, onClick: function () {
                    json && template && createExportMutation.mutate({ dataMapping: json, template: template, flag: flag });
                    setJson(undefined);
                    setJsonName(undefined);
                    setTemplate(undefined);
                    setTemplateName(undefined);
                    toast.success('Done!');
                } }))));
}
export default ExportConfiguration;
